// extracted by mini-css-extract-plugin
module.exports = {"section-title":"Experiencee_section-title__3jBeG"};